/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
import Promise from 'bluebird';
import OSjsTransport from 'vfs/transports/osjs';
import MountManager from 'core/mount-manager';
import {getBrowserPath} from 'core/config';
import {_} from 'core/locales';

/**
 * Dist VFS Transport Module
 *
 * This is just an override of the default OS.js transport module
 *
 * @extends OSjsTransport
 */
export default class DistTransport extends OSjsTransport {

  request(method, args, options) {
    if ( ['url', 'scandir', 'read'].indexOf(method) === -1 ) {
      return Promise.reject(new Error(_('ERR_VFS_UNAVAILABLE')));
    }

    return super.request(...arguments);
  }

  url(item) {
    const root = getBrowserPath();
    const module = MountManager.getModuleFromPath(item.path);
    const url = item.path.replace(module.option('match'), root).replace(/^\/+/, '/');

    return Promise.resolve(url);
  }

}



// WEBPACK FOOTER //
// ./javascript/vfs/transports/dist.js